import React, { PureComponent } from 'react';
import withResponsive from 'src/lib/hoc/withResponsive';
import PropTypes from 'prop-types';
import { getIsFilter, getIsFixedSearchBar } from 'src/lib/redux/modules/search';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import debug from 'src/lib/logger';
import { SearchIcon } from 'src/components/SearchIcon';
import FilterButton from 'src/components/FilterButton';
import TrackingManager from 'src/lib/managers/TrackingManager';
import { OFFSET_FROM_TOP } from 'src/lib/constants/general';
import TestsManager from 'src/lib/managers/TestsManager';
import { SB_SCROLL } from 'src/lib/constants/tests';

const CategoriesDropDown = dynamic(
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "cat-drop" */ 'src/components/CategoriesDropDown/CategoriesDropDown'),
	{
		ssr: false,
	}
);

const Filters = dynamic(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "filters" */ 'src/components/Filters/Filters'), {
	ssr: false,
});

const SearchBar = dynamic(() =>
	import(/* webpackMode: "lazy" */ /* webpackChunkName: "search-bar" */ 'src/components/SearchBar/SearchBar')
);

const Logo = dynamic(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "logo" */ 'src/components/Logo/Logo'), { ssr: false });

const prefixStyles = 'HDR_';

@connect(
	state => ({
		isFilter: getIsFilter(state.search),
		isFixedSearchBar: getIsFixedSearchBar(state.search),
	}),
	dispatch => ({
		dispatch,
	})
)
@withResponsive()
export default class Header extends PureComponent {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		responsive: PropTypes.object,
		isFilterButton: PropTypes.bool,
		isFilter: PropTypes.bool,
		contentStyles: PropTypes.object,
		filterStyles: PropTypes.object,
		searchBarStyles: PropTypes.object,
		logoWrapperStyles: PropTypes.object,
		onSearch: PropTypes.func,
		isSearchBar: PropTypes.bool,
		isRusty: PropTypes.bool,
	};

	static defaultProps = {
		responsive: {},
		isFilterButton: true,
		isFilter: false,
		contentStyles: {},
		filterStyles: { width: '260px' },
		searchBarStyles: {},
		logoWrapperStyles: { maxWidth: '200px' },
		onSearch: null,
		isSearchBar: true,
		isRusty: false,
	};

	componentDidMount = () => {
		window.addEventListener('scroll', this.handleScroll);
	};

	componentWillUnmount = () => {
		const { responsive } = this.props;
		const { isMobile } = responsive;
		window.removeEventListener('scroll', this.handleScroll);
		if (isMobile) {
			document.body.classList.remove(prefixStyles + 'fixed-nav');
			document.body.style.paddingTop = 0;
		}
	};

	stickyHeader = () => {
		const { responsive } = this.props;
		const { isMobile } = responsive;
		if (!isMobile) {
			return;
		}
		const offsetFromTop = window.pageYOffset || document.documentElement.scrollTop;
		if (offsetFromTop >= OFFSET_FROM_TOP) {
			if (!TestsManager.isInTestGroup(SB_SCROLL, 1)) {
				document.body.style.paddingTop = '50px';
			}
			document.body.classList.add(prefixStyles + 'fixed-nav');
		} else {
			document.body.classList.remove(prefixStyles + 'fixed-nav');
			document.body.style.paddingTop = 0;
		}
	};

	handleScroll = () => {
		this.stickyHeader();
	};

	onClickSearchIcon = () => {
		const { isFixedSearchBar } = this.props;
		if (!isFixedSearchBar) {
			TrackingManager.trackEvent('Search Icon Click');
		}
		window.scroll({ top: 0, left: 0, behavior: 'auto' });
	};

	render = () => {
		const { isFilterButton, contentStyles, logoWrapperStyles, searchBarStyles, onSearch, isSearchBar, isFilter, responsive } =
			this.props;
		const { isMobile, isSmallTablet, isTablet, isLaptop, currentDevice } = responsive;
		const isMobileOrTablet = isMobile || isSmallTablet || isTablet;
		if (typeof window !== 'undefined') {
			debug(`Header - fresh ${currentDevice} filter : ${isMobileOrTablet}`);
		}

		return (
			<div data-device={currentDevice} className={prefixStyles + 'freshHeader'}>
				<div style={contentStyles} className={prefixStyles + 'header-content'}>
					<div className={prefixStyles + 'mobileWrapper'}>
						<div style={logoWrapperStyles} className={prefixStyles + 'search-bar-logo'}>
							<Logo />
						</div>
						<div className={prefixStyles + 'actions'}>
							{isMobileOrTablet && (
								<button className={prefixStyles + 'fixed-search-icon'} type="submit" onClick={this.onClickSearchIcon}>
									<SearchIcon />
								</button>
							)}
							{isFilterButton && isMobileOrTablet && <FilterButton />}
						</div>
					</div>
					{isSearchBar && (
						<div className={prefixStyles + 'searchBarWrapper'} style={isLaptop ? {} : searchBarStyles}>
							<SearchBar submitQuery={onSearch} />
						</div>
					)}
					{isLaptop && (
						<div className={prefixStyles + 'dropdownWrapper'}>
							<CategoriesDropDown />
						</div>
					)}
				</div>
				{isFilter && isMobileOrTablet ? <Filters /> : null}
			</div>
		);
	};
}
